import moment from 'moment';

const currentDate = moment().format('M/YY');

export default [
  { id: 1, key: 'portfolio', title: 'Portfolio', isSortable: false },
  { id: 2, key: 'currentAllocation', title: `${currentDate} Alloc`, isSortable: true },
  { id: 3, key: 'currentInvestment', title: `${currentDate} Investment`, isSortable: true },
  { id: 4, key: 'currentPerformance', title: `${currentDate} Perf`, isSortable: true },
  { id: 5, key: 'currentPnl', title: `${currentDate} P&L`, isSortable: true },
  { id: 6, key: 'qtdPerformance', title: 'QTD Perf', isSortable: true },
  { id: 7, key: 'qtdPnl', title: 'QTD P&L', isSortable: true },
  { id: 8, key: 'ytdPerformance', title: 'YTD Perf', isSortable: true },
  { id: 9, key: 'ytdPnl', title: 'YTD P&L', isSortable: true },
  { id: 10, key: 'itdPerformance', title: 'ITD Perf', isSortable: true },
  { id: 11, key: 'itdPnl', title: 'ITD P&L', isSortable: true }
];
